const fontWeights: FontWeightProps = {
  light: '300',
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  black: '900',
};

export interface FontWeightProps {
  [key: string]: string;
}

export default fontWeights;
